import "./TradingIdeasPlaceControlComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {ReplaySubject, Scheduler} from "rxjs";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";
import {PlaceOrderService} from "../../../../portfolio/templates/ticket/services/PlaceOrderService";
import {PortfolioType} from "../../../../portfolio/models/Portfolio";
import {TradeIdeasViewModel} from "../../../models/TradeIdeasViewModel";
import {Strategy} from "../../../../portfolio/templates/ticket/types/WhatIf";
import {AccountStore} from "../../../../account/store/AccountStore";
import {isNotNull} from "../../../../js/util/UtilFunctions";

export const TradingIdeasPlaceControl = "tfTradingIdeasPlaceControl";

export function tradingIdeasPlaceControl(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/controls/place/TradingIdeasPlaceControlComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasPlaceControlComponentController
    };
}

export class TradingIdeasPlaceControlComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    private readonly placeTrade$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly accountStore: AccountStore,
                       private readonly placeOrderService: PlaceOrderService) {

    }

    public $onInit(): void {
        this.watchPlaceTrade();
    }

    private watchPlaceTrade() {
        const currentAccount$ = this.accountStore.current.filter(isNotNull);
        this.placeTrade$
            .throttleTime(5000)
            .observeOn(Scheduler.async)
            .takeUntil(this.destroyed$)
            .withLatestFrom(this.store.currentModel, currentAccount$)
            .subscribe(([_, model, account]) => {
                const strategy = this.modelToStrategy(model);
                const showDisclaimer = account.portfolioType !== PortfolioType.SIMULATED;
                this.placeOrderService.openOrderWindowFromTradeIdea(strategy,
                                                                    account.id,
                                                                    showDisclaimer,
                                                                    model.targetPrice);
            });
    }

    private modelToStrategy(model: TradeIdeasViewModel): Strategy {
        return {
            name: model.idea.name,
            tmc: true,
            scaleFactor: model.riskAmount.currentLots,
            trades: Array.from(model.trades()) // One day we won't need mutable arrays and this can be removed...
        };
    }

    public placeTrade() {
        this.placeTrade$.next(true);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
